import React from 'react';
import {Page, Text, Image, Link, View, Document, StyleSheet, Font} from '@react-pdf/renderer';
import logo from "../logo-big.jpg";
import font from "../fonts/old-fonts/Montserrat-Regular.ttf"




Font.register({
    family: "Montserrat",
    format: "truetype",
    src: font
});

const brandColor = process.env.REACT_APP_BRAND_COLOR ?? '#333333';

// Create styles
const styles = StyleSheet.create({
    page: {
        height: 842,
        backgroundColor: '#FFFFFF',
        fontFamily:  'Montserrat',
        fontSize: 7,
    },
    header: {
        flexDirection: 'row',
        paddingHorizontal: 40,
        marginTop: 60,
    },
    content: {
        flexDirection: 'row'
    },
    footer: {
        flexDirection: 'row',
        position: 'absolute',
        bottom: 40
    },
    headerLeft: {
        width: 400,
        paddingLeft:40
    },
    headerRight: {
        width:245,
        maxWidth: 245,
        paddingRight:20
    },
    logo: {
        width: 80,
    },
    contentLeft: {
        width:350,
        paddingLeft: 40,
        overflow: 'visible'
    },
    image: {
        width:200
    },
    contentRight: {
        width:250,
        paddingRight:20
    },
    contentBottom: {
        flexDirection: 'row',
        borderTop: 1,
        borderBottom: 1,
        borderColor: '#eee',
        paddingVertical: 40,
        alignContent: 'top',
        marginHorizontal: 20,
        marginTop: 40,
    },
    footerTop: {

    },
    footerLeft: {
        width: 270,
        paddingLeft: 40
    },
    footerRight: {
        width: 320,
        justifyContent: 'right',
        paddingRight: 40,
        alignItems: 'right'
    },
    title: {
        fontSize: 22,
        fontWeight: 'Bold',
    },
    price: {
        fontSize: 9,
        display: 'flex',
        fontWeight: 600,
    },
    unitSize: {
        fontSize: 9,
    },
    vintage: {
        fontSize: 14,
        paddingBottom: 10,
    },
    subtitle: {
        fontSize: 13,
        fontWeight: 700,
        paddingTop: 20,
        paddingBottom: 5,
        display: 'Block',
        width:350
    },
    subtitle2: {
        fontSize: 13,
        width:310,
        paddingBottom: 5,
        paddingTop: 10,
    },
    notesGroup: {

    },
    notesItem: {
        marginTop:25
    },
    notes: {
        fontSize: 9,
    },
    fields: {
        paddingTop: 5
    },
    icon_fields: {
        backgroundColor: brandColor,
},
    disclaimer: {
        paddingTop: 10,
        borderTop: '1px solid #ddd'
    },
    right: {
        textAlign: 'right'
    },
    field: {
        paddingRight: 5
        },
    lastField: {
    },
    typeGroup: {

    },
    iconFieldContainer: {
        flex: 1,
        alignContent: 'space-between',
        justifyContent: 'center',
        height:120
    },
    iconFieldBg: {
        height: 60,
        width: 60,
        color: 'White',
        borderRadius: 50,
        alignSelf: 'start',
        justifyContent: 'center',
        margin: 'auto',
        backgroundColor: brandColor
    },
    iconFieldLabel: {
        margin: 'auto',
        fontSize: 11,
        fontWeight: 'strong'
    },
    iconField: {
        alignSelf: 'end',
        marginTop: 10,
height:50,
        fontSize: 13,
        color: brandColor,
    },
    iconFieldText: {
        marginHorizontal: 'auto',
fontSize:10
    }
});

const Br = () => "\n";

// Create Document Component
const TastingNotes = (props) => (

    <Document title={props.product.Code + " " + props.product.Description}>
        <Page size="A4" style={styles.page}>
            <View style={styles.header}>
                <Text style={styles.title}>{props.product.Description}</Text>
            </View>
            <View style={styles.content}>
                <View style={styles.contentLeft}>
                    <Text style={styles.vintage}>{props.product.Vintage}</Text>
                    <Text style={{fontSize: 9}}>{props.product.Code}
                    {((process.env.REACT_APP_ONLY_SELL_MULTIPLES_OF && props.product.OnlySellMultiplesOf <= 1 && process.env.REACT_APP_UNIT_FLAG !== "2") || (!process.env.REACT_APP_ONLY_SELL_MULTIPLES_OF && process.env.REACT_APP_UNIT_FLAG !== "2")) && props.product.CaseSize > 1 &&
                        <>  |  {window.currency}{(Math.round((props.product.BottleNett * 1000) / 10) / 100).toFixed(2)} (1 x {props.product.UnitSize}cl)</>
                    }
                    {process.env.REACT_APP_UNIT_FLAG !== "1" &&
                        <>  |  {window.currency}{(Math.round((props.product.CasePrice * 1000) / 10) / 100).toFixed(2)} ({props.product.CaseSize} x {props.product.UnitSize}cl)</>
                    }
                    </Text>

                  {props.notesGroup.length > 0 && props.notesGroup.map((item) => (
                    <>
                      <Text style={styles.subtitle}>{item.title}</Text>
                      <Text style={styles.notesGroup}>
                          <Text style={styles.notesItem}>
                            <Text style={styles.notes}>{item.value.replace(/\n/g, " ")}</Text>
                          </Text>
                      </Text>
                    </>
                  ))}


                        <Text>
                    {props.suggestionGroup.length > 0 &&
                        <>
                    {props.suggestionGroup.map((item) => (
                        <Text style={styles.notes}>{item}</Text>
                        ))}
                        </>}
                        </Text>


                </View>

                <View style={styles.contentRight}>

                    <Image style={styles.image} src={props.image}>
                    </Image>

                </View>
            </View>
                <View style={styles.contentBottom}>

                    {process.env.REACT_APP_VINTAGE_DISPLAY === "1" && props.product.Vintage !== "    " && props.product.Vintage !== " " &&
                            <View style={styles.iconFieldContainer}>
                                <View style={styles.iconFieldBg}>
                                <Text style={styles.iconFieldLabel}>Vintage</Text>
                                </View>
                                <View style={styles.iconField}>
                                    <Text style={styles.iconFieldText}>{props.product.Vintage}</Text>
                                </View>
                            </View>
                   }
                    {process.env.REACT_APP_LOCATION_DISPLAY === "1" && props.locationGroup.length > 0 &&
                        <View style={styles.iconFieldContainer}>
                            <View style={styles.iconFieldBg}>
                                <Text style={styles.iconFieldLabel}>Origin</Text>
                            </View>
                            <View style={styles.iconField}>
                            {props.locationGroup.map((item) => (
                                <Text style={styles.iconFieldText}>{item}</Text>
                            ))}
                            </View>
                        </View>
                   }
                    {process.env.REACT_APP_TYPE_DISPLAY === "1" && props.typeGroup.length > 0 &&
                            <View style={styles.iconFieldContainer}>
                                <View style={styles.iconFieldBg}>
                                    <Text style={styles.iconFieldLabel}>Type</Text>
                                </View>
                                <View style={styles.iconField}>
                                {props.typeGroup.map((item) => (
                                    <Text style={styles.iconFieldText}>{item}</Text>
                                ))}
                                </View>
                            </View>
                 }
                    {process.env.REACT_APP_ABV_DISPLAY === "1" && props.product.AlcoholicPercentage !== '' &&
                        <View style={styles.iconFieldContainer}>
                            <View style={styles.iconFieldBg}>
                                <Text style={styles.iconFieldLabel}>ABV</Text>
                            </View>
                            <View style={styles.iconField}>
                            <Text style={styles.iconFieldText}>{props.product.AlcoholicPercentage}%</Text>
                            </View>
                        </View>
                  }

                    {process.env.REACT_APP_SUITABLE_DISPLAY === "1" && props.suitableGroup.length > 0 &&
                        <View style={styles.iconFieldContainer}>
                        <View style={styles.iconFieldBg}>
                        <Text style={styles.iconFieldLabel}>Suitable</Text>
                        </View>
                        <View style={styles.iconField}>
                    {props.suitableGroup.map((item) => (
                        <Text style={styles.iconFieldText}>{item}</Text>
                        ))}
                        </View>
                        </View>

                    }

                    {process.env.REACT_APP_ALLERGEN_DISPLAY === "1" && props.allergenGroup.length > 0 &&
                        <View style={styles.iconFieldContainer}>
                            <View style={styles.iconFieldBg}>
                                <Text style={styles.iconFieldLabel}>Allergens</Text>
                            </View>
                            <View style={styles.iconField}>
                                {props.allergenGroup.map((item) => (
                                    <Text style={styles.iconFieldText}>{item}</Text>
                                ))}
                            </View>
                        </View>

                    }

                        {process.env.REACT_APP_EXCISE_DISPLAY === "1" && props.product.ExciseDescription !== '' &&

                        <View style={styles.iconFieldContainer}>
                            <View style={styles.iconFieldBg}>
                                <Text style={styles.iconFieldLabel}>Excise</Text>
                            </View>
                            <View style={styles.iconField}>
                                <Text style={styles.iconFieldText}>{props.product.ExciseDescription}</Text>
                            </View>
                        </View>
                    }

                </View>
            <View style={styles.footerTop}>

            </View>
            <View style={styles.footer}>
                <View style={styles.footerLeft}>
                    <Text>{process.env.REACT_APP_COMPANY_NAME}</Text>
                    <Text>{process.env.REACT_APP_ADDRESS}</Text>
                    <Text style={styles.fields}>{process.env.REACT_APP_PHONE}</Text>
                    <Link style={styles.fields} src={`mailto:${process.env.REACT_APP_EMAIL}`}>{process.env.REACT_APP_EMAIL}</Link>
                    <Text style={styles.disclaimer}>Information correct as of {new Date().toLocaleString() + ""}</Text>
                    <Text>© {new Date().getFullYear()} All rights reserved</Text>
                </View>
                <View style={styles.footerRight}>
                    <Image style={styles.logo} src={logo}>
                    </Image>
                </View>
            </View>
        </Page>
    </Document>
);

export default TastingNotes;